/**
 * GF Product Form (Optimized V2)
 * Single-fetch architecture: Adds item AND fetches updated cart HTML in one request.
 */

if (!customElements.get('gf-product-form')) {
    customElements.define('gf-product-form', class GFProductForm extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector('form');
            this.submitBtn = this.form.querySelector('[type="submit"], [name="add"]');
            this.form.addEventListener('submit', this.onSubmit.bind(this));
        }

        onSubmit(event) {
            event.preventDefault();
            if (this.submitBtn.classList.contains('gf-btn-loading')) return;

            this.handleErrorMessage();
            this.setLoading(true);

            const config = {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/javascript'
                }
            };

            const formData = new FormData(this.form);

            // Critical Optimization: Request the updated drawer HTML in the SAME request
            // This avoids a second round-trip fetch.
            formData.append('sections', 'gf-cart-drawer,gf-header');
            formData.append('sections_url', window.location.pathname);

            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        this.handleErrorMessage(response.description);
                        this.setLoading(false);
                        return;
                    }

                    // Success - Response contains the added item AND the requested sections

                    this.setLoading(false);
                    this.setSuccessState();

                    // Show Toast Notification (Universal)
                    if (window.GFToast) {
                        window.GFToast.show(response.image, response.product_title || 'Producto agregado');
                    }

                    // Dispatch event with the FULL response (including sections)
                    const event = new CustomEvent('gf:cart:updated', {
                        bubbles: true,
                        detail: { cart: response }
                    });
                    this.dispatchEvent(event);

                    // Open Drawer (if global object exists)
                    // Added small timeout to ensure DOM update finishes first
                    if (window.GFCart && window.GFCart.open) {
                        setTimeout(() => window.GFCart.open(), 100);
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.handleErrorMessage('Error de conexión. Inténtalo de nuevo.');
                    this.setLoading(false);
                });
        }

        setLoading(isLoading) {
            if (!this.submitBtn) return;

            if (isLoading) {
                // Backup original text
                if (!this.submitBtn.dataset.originalText) {
                    this.submitBtn.dataset.originalText = this.submitBtn.innerHTML;
                }

                // Show Jumping Dots (Universal)
                this.submitBtn.style.height = `${this.submitBtn.offsetHeight}px`;
                this.submitBtn.classList.add('gf-btn-loading'); // Universal loading class
                // Added explicit dimensions to container
                this.submitBtn.innerHTML = '<div class="gf-dots-loader"><span></span><span></span><span></span></div>';
                this.submitBtn.setAttribute('disabled', true);
            } else {
                this.submitBtn.classList.remove('gf-btn-loading');
                this.submitBtn.removeAttribute('disabled');
            }
        }

        setSuccessState() {
            if (!this.submitBtn) return;

            this.submitBtn.classList.add('gf-btn-success');
            this.submitBtn.innerHTML = '<span>¡Agregado!</span>';

            setTimeout(() => {
                this.submitBtn.classList.remove('gf-btn-success');
                // Restore original content
                if (this.submitBtn.dataset.originalText) {
                    this.submitBtn.innerHTML = this.submitBtn.dataset.originalText;
                    this.submitBtn.style.height = '';
                }
            }, 3000);
        }



        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.gf-form-error');
            if (!this.errorMessageWrapper) return;
            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
            if (errorMessage) {
                this.errorMessageWrapper.textContent = errorMessage;
            }
        }
    });
}
